






































import { VerifiedUsers } from '@/jbi-shared/types/user.types';
import { Debounce } from '@/jbi-shared/util/debounce.vue-decorator';
import { GetFilteredVerifiedUserListPayload } from '@/store/modules/admin/types/admin.types';
import { RootState } from '@/store/store';
import { ApiState } from '@/store/types/general.types';
import { boldSearchKeywords } from '@/utils/search.util';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

@Component({})
export default class UserLookupAutoComplete extends Vue {
  @Prop({ type: String, default: '' }) name!: string;
  selectedUser: VerifiedUsers[] = [];
  userList: VerifiedUsers[] = [];
  isActive: boolean = false;
  searchInput = '';

  @Action('admin/getFilteredVerifiedUserList')
  public getFilteredVerifiedUserList!: (
    params: GetFilteredVerifiedUserListPayload
  ) => Promise<void>;

  @State(({ admin }: RootState) => admin.apiState.getFilterVerifiedUsers)
  public getFilteredVerifiedUsersApiState!: ApiState;

  @State(({ admin }: RootState) => admin.filteredVerifiedUsers)
  public filteredVerifiedUsers!: VerifiedUsers[];

  created() {
    this.getUserList(this.name);
  }

  mounted() {
    if (this.name !== '') {
      this.searchInput = this.name;
    }
  }

  getUserList(searchInput: string): void {
    this.getFilteredVerifiedUserList({
      searchInput,
      page: 1,
      limit: 100
    });
  }

  toggleIsActive() {
    this.isActive = !this.isActive;
  }

  @Debounce(300)
  userInput(userInput: string) {
    this.searchInput = userInput;
    this.getUserList(userInput);
  }

  assignSelectedUser(option: VerifiedUsers) {
    if (!option) {
      this.selectedUser = [];
      return;
    }

    this.selectedUser = [option];
  }

  displayInitials(user: VerifiedUsers): string {
    if (user.firstName && user.lastName) {
      return user.firstName!.charAt(0).toUpperCase();
    }
    return 'U';
  }

  userLabel(user: VerifiedUsers): string {
    const label = `${user.firstName} ${user.lastName}`;
    return boldSearchKeywords(label, this.searchInput);
  }

  @Watch('getFilteredVerifiedUsersApiState', { deep: true })
  onStateChanged(state: ApiState) {
    if (state.success) {
      this.userList = this.filteredVerifiedUsers;
    }

    if (this.userList.length === 0) {
      this.$emit('noUserFound', this.searchInput);
    }
  }

  /**
   * Watcher used to initiate list reload upon field clearing via b-autocomplete
   * "clearable". This was created to address
   */
  @Watch('searchInput')
  onSearchInputUpdated() {
    this.getUserList(this.searchInput);
  }

  @Watch('selectedUser')
  public onSelectItems() {
    if (!this.selectedUser.length) {
      this.$emit('selectedUser', null);
      return;
    } else {
      this.$emit('selectedUser', this.selectedUser[0]);
    }
  }
}
